import * as yup from "yup";
import { MESSAGE_ERREUR_CHAMP_OBLIGATOIRE, MESSAGE_ERREUR_EMAIL_OBLIGATOIRE, MESSAGE_ERREUR_NOM_OBLIGATOIRE, MESSAGE_ERREUR_REGEXP_TELEPHONE } from "../../../data/message-erreurs-form";

export const nousContacterSchema = yup.object({
    Nom: yup.string().required(MESSAGE_ERREUR_NOM_OBLIGATOIRE),
    Email: yup.string().email("Saisie incorrecte").required(MESSAGE_ERREUR_EMAIL_OBLIGATOIRE),
    Telephone: yup.string()
        .required(MESSAGE_ERREUR_REGEXP_TELEPHONE)
        .matches(/^\+[1-9]\d{1,14}$/, MESSAGE_ERREUR_REGEXP_TELEPHONE),
    Message: yup.string().required(MESSAGE_ERREUR_CHAMP_OBLIGATOIRE),
    IdSujet: yup.number().nullable().required(MESSAGE_ERREUR_CHAMP_OBLIGATOIRE).typeError(MESSAGE_ERREUR_CHAMP_OBLIGATOIRE)
    ,
})